export default __webpack_public_path__ + "static/media/xsx-icon-disable.04522997.svg";